import React, { useState, useRef } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { SORT_METHODS } from '../../../../../lib/constants'
import actions from './actions'
import Button from '../../../../Button'
import Radio from '../../../../Form/Radio'
import SortIcon from '../../../../../assets/svg/SortIcon'
import styles from './FeatureFilter.module.scss'
import useOnClickOutside from '../../../../../lib/hooks/useOnClickOutside'

function FeatureFilter(props) {
	const [isOpen, setIsOpen] = useState(false)
	const [sortMethod, setSortMethod] = useState((' ' + props.sort).slice(1))
	const [filterTypes, setFilterTypes] = useState([...props.filterTypes])
	const contextMenuRef = useRef(null)
	const displayFilters = () => {
		setIsOpen(!isOpen)
	}
	useOnClickOutside(contextMenuRef, () => {
		setIsOpen(false)
		setSortMethod((' ' + props.sort).slice(1))
		setFilterTypes([...props.filterTypes])
	})

	const changeSort = (e) => {
		if (e.target.checked) {
			setSortMethod(e.target.value)
		} else {
			setSortMethod((' ' + props.sort).slice(1))
		}
	}

	const sortOptions = Object.keys(SORT_METHODS).map((method, i) => {
		return <Radio checked={sortMethod === method} className={styles.sortOption} id={method} key={i} label={SORT_METHODS[method]} name='sort' onChange={changeSort} value={method} />
	})

	const applyFilters = () => {
		props.applyFilters(sortMethod, filterTypes)
		setIsOpen(!isOpen)
	}

	return (
		<div className={styles.container} ref={contextMenuRef}>
			<Button disabled={props.disableFilters} onClick={displayFilters} theme={Button.THEME.solidSecondary} size={Button.SIZE.small} style={{ width: '36px', padding: '5px' }}>
				<SortIcon size='16px' color='#fff' />
			</Button>
			<div style={{ display: isOpen ? 'block' : 'none' }} className={styles.dropdown}>
				<h3>Sort</h3>
				{sortOptions}
				<div className={styles.actions}>
					<Button onClick={applyFilters} theme={Button.THEME.solidPrimary} size={Button.SIZE.small}>
						Apply
					</Button>
				</div>
			</div>
		</div>
	)
}

FeatureFilter.propTypes = {
	disableFilters: PropTypes.bool,
	filterTypes: PropTypes.array,
	sort: PropTypes.string,
	// actions
	applyFilters: PropTypes.func,
	resetFilters: PropTypes.func,
}

export default connect((model) => {
	const { disableFilters, filters, sort } = model.features
	const filterTypes = filters.types
	return {
		disableFilters,
		filterTypes,
		sort,
	}
}, actions)(FeatureFilter)
